var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGifticon = function SvgGifticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 5.1H4.85a1.75 1.75 0 1 1 0-3.5C7.3 1.6 8 5.1 8 5.1Zm0 0h3.15a1.75 1.75 0 0 0 0-3.5C8.7 1.6 8 5.1 8 5.1Zm0 0v10.5M1 10h14M1 7.34v6.02c0 .785 0 1.177.153 1.476a1.4 1.4 0 0 0 .611.612c.3.153.692.153 1.476.153h9.52c.784 0 1.176 0 1.476-.153a1.4 1.4 0 0 0 .611-.612c.153-.3.153-.691.153-1.475V7.34c0-.784 0-1.176-.153-1.476a1.4 1.4 0 0 0-.611-.612c-.3-.152-.692-.152-1.476-.152H3.24c-.784 0-1.176 0-1.476.152a1.4 1.4 0 0 0-.611.612C1 6.165 1 6.557 1 7.341Z"
  })));
};
export default SvgGifticon;